import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Typography,
  CircularProgress,
} from "@mui/material";

interface DeleteLandingPageDialogProps {
  open: boolean;
  contentName?: string;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export const DeleteLandingPageDialog: React.FC<
  DeleteLandingPageDialogProps
> = ({
  open,
  contentName,
  onClose,
  onConfirm,
  isDeleting = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={isDeleting ? undefined : onClose}
      maxWidth="sm"
     
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
        },
      }}
    >
      <DialogContent sx={{ p: 4 }}>
        {/* Title */}
        <Typography
          variant="h6"
          fontWeight={600}
          textAlign="center"
          mb={1}
        >
          Delete Content?
        </Typography>

        {/* Description */}
        <Typography
          variant="body2"
          color="text.secondary"
          textAlign="center"
        >
          This action cannot be undone.
        </Typography>

        {/* Content Name */}
        {contentName && (
          <Typography
            variant="subtitle1"
            fontWeight={600}
            textAlign="center"
            mt={2}
          >
            {contentName}
          </Typography>
        )}

        {/* Actions */}
        <Box
          display="flex"
          justifyContent="center"
          gap={2}
          mt={4}
        >
          <Button
            onClick={onClose}
            disabled={isDeleting}
            variant="outlined"
          >
            Cancel
          </Button>

          <Button
            onClick={onConfirm}
            disabled={isDeleting}
            variant="contained"
            color="error"
            sx={{ minWidth: 140 }}
          >
            {isDeleting ? (
              <Box display="flex" alignItems="center" gap={1}>
                <CircularProgress size={16} color="inherit" />
                Deleting
              </Box>
            ) : (
              "Delete"
            )}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
